import Phaser from "phaser";
export default class WinScene extends Phaser.Scene {

    constructor() {
        super('win-scene')
    }

    init(data){
        this.replayButton = undefined
        this.score = data.score
    }

    preload() {
        this.load.image('background', 'images/start_bg.jpg')
        this.load.image('win-bg', 'images/win.png')
        this.load.image('replaywin-button', 'images/replay.png')
    }

    create(){

        const gameWidth = this.scale.width * 0.5
        const gameHeight = this.scale.height * 0.5

        this.add.image(gameWidth, gameHeight, 'background').setScale(0.38)
        this.add.image(210, 270, 'win-bg').setScale(1)

        
                

        this.add.text(120, 100, 'Score: ', {
			fontSize: '33px',
			color: '#FFFFFF',
		});
		this.add.text(250, 100, this.score, {
			fontSize: '33px',
			color: '#FFFFFF',
		});

        this.replayButton = this.add.image(220, 500, 'replaywin-button').setInteractive().setScale(0.6)

        // ketika di klik, scene akan berpindah ke BunnyJumpScene
        this.replayButton.once('pointerup', () => {
            this.scene.start('hunting-alien-io')
        }, this)
        
    }
}